var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("h2", { staticClass: "card-title" }, [
        _vm._v(_vm._s(_vm.T.loginSignupHeader)),
      ]),
    ]),
    _c("div", { staticClass: "card-body" }, [
      !_vm.useSignupFormWithBirthDate
        ? _c("form", [
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-username" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginAccountName)),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-signup-username": "",
                        name: "reg_username",
                        autocomplete: "username",
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.username = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _c("div", { staticClass: "col-md-4 introjs-email" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.T.loginEmail)),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      "data-signup-email": "",
                      name: "reg_email",
                      type: "email",
                      autocomplete: "email",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-password" },
                [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.T.loginPasswordCreate)),
                      ]),
                      _c("omegaup-password-input", {
                        attrs: {
                          "data-signup-password": "",
                          name: "reg_password",
                          autocomplete: "new-password",
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticClass: "col-md-4 introjs-confirmpassword" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginRepeatPassword)),
                    ]),
                    _c("omegaup-password-input", {
                      attrs: {
                        "data-signup-repeat-password": "",
                        name: "reg_password_confirmation",
                        autocomplete: "new-password",
                      },
                      model: {
                        value: _vm.passwordConfirmation,
                        callback: function ($$v) {
                          _vm.passwordConfirmation = $$v
                        },
                        expression: "passwordConfirmation",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-8 introjs-terms-and-conditions" },
                [
                  _c("div", { staticClass: "checkbox-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.privacyPolicyAccepted,
                          expression: "privacyPolicyAccepted",
                        },
                      ],
                      attrs: {
                        id: "accept-privacy-policy",
                        "data-signup-accept-policies": "",
                        type: "checkbox",
                        required: "",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.privacyPolicyAccepted)
                          ? _vm._i(_vm.privacyPolicyAccepted, null) > -1
                          : _vm.privacyPolicyAccepted,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.privacyPolicyAccepted,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.privacyPolicyAccepted = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.privacyPolicyAccepted = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.privacyPolicyAccepted = $$c
                          }
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "pl-1",
                        attrs: { for: "accept-privacy-policy" },
                      },
                      [
                        _c("omegaup-markdown", {
                          attrs: {
                            markdown: _vm.formattedAcceptPolicyMarkdown,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "checkbox-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.codeOfConductAccepted,
                          expression: "codeOfConductAccepted",
                        },
                      ],
                      attrs: {
                        id: "accept-code-of-conduct",
                        "data-signup-accept-conduct": "",
                        type: "checkbox",
                        required: "",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.codeOfConductAccepted)
                          ? _vm._i(_vm.codeOfConductAccepted, null) > -1
                          : _vm.codeOfConductAccepted,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.codeOfConductAccepted,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.codeOfConductAccepted = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.codeOfConductAccepted = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.codeOfConductAccepted = $$c
                          }
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "pl-1",
                        attrs: { for: "accept-code-of-conduct" },
                      },
                      [
                        _c("omegaup-markdown", {
                          attrs: {
                            markdown: _vm.formattedAcceptConductMarkdown,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm.validateRecaptcha
                ? _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("vue-recaptcha", {
                        attrs: {
                          name: "recaptcha",
                          sitekey: "6LfMqdoSAAAAALS8h-PB_sqY7V4nJjFpGK2jAokS",
                        },
                        on: { verify: _vm.verify, expired: _vm.expired },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-md-4 col-md-offset-6" }, [
                _c("div", { staticClass: "form-group introjs-register" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary form-control",
                      attrs: {
                        "data-signup-submit": "",
                        name: "sign_up",
                        type: "submit",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$emit("register-and-login", {
                            username: _vm.username,
                            email: _vm.email,
                            password: _vm.password,
                            passwordConfirmation: _vm.passwordConfirmation,
                            recaptchaResponse: _vm.recaptchaResponse,
                            termsAndPolicies: _vm.termsAndPolicies,
                          })
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.T.loginSignUp) + " ")]
                  ),
                ]),
              ]),
            ]),
          ])
        : _c("form", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4 offset-md-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "pl-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.over13Checked,
                          expression: "over13Checked",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        "data-over-thirteen-checkbox": "",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.over13Checked)
                          ? _vm._i(_vm.over13Checked, null) > -1
                          : _vm.over13Checked,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.over13Checked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.over13Checked = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.over13Checked = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.over13Checked = $$c
                            }
                          },
                          _vm.updateDateRestriction,
                        ],
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.T.over13yearsOld) + " "),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _vm.isUnder13
                ? _c("div", { staticClass: "col-md-8 offset-md-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.T.loginParentEmail)),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.parentEmail,
                            expression: "parentEmail",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          name: "reg_parent_email",
                          type: "email",
                          autocomplete: "parent-email",
                        },
                        domProps: { value: _vm.parentEmail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.parentEmail = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "col-md-8 offset-md-2 introjs-email" },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(_vm.T.loginEmail)),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            "data-signup-email": "",
                            name: "reg_email",
                            type: "email",
                            autocomplete: "email",
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.email = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-username" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginAccountName)),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-signup-username": "",
                        name: "reg_username",
                        autocomplete: "username",
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.username = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.T.loginDateOfBirth)),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dateOfBirth,
                        expression: "dateOfBirth",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "reg_date_of_birth",
                      type: "date",
                      autocomplete: "date-of-birth",
                      max: _vm.maxDateForTimepicker,
                      min: _vm.minDateForTimepicker,
                    },
                    domProps: { value: _vm.dateOfBirth },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.dateOfBirth = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-password" },
                [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.T.loginPasswordCreate)),
                      ]),
                      _c("omegaup-password-input", {
                        attrs: {
                          "data-signup-password": "",
                          name: "reg_password",
                          autocomplete: "new-password",
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticClass: "col-md-4 introjs-confirmpassword" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginRepeatPassword)),
                    ]),
                    _c("omegaup-password-input", {
                      attrs: {
                        "data-signup-repeat-password": "",
                        name: "reg_password_confirmation",
                        autocomplete: "new-password",
                      },
                      model: {
                        value: _vm.passwordConfirmation,
                        callback: function ($$v) {
                          _vm.passwordConfirmation = $$v
                        },
                        expression: "passwordConfirmation",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-10 introjs-terms-and-conditions" },
                [
                  _c("div", { staticClass: "checkbox-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.privacyPolicyAccepted,
                          expression: "privacyPolicyAccepted",
                        },
                      ],
                      attrs: {
                        id: "accept-privacy-policy-birthdate",
                        "data-signup-accept-policies": "",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.privacyPolicyAccepted)
                          ? _vm._i(_vm.privacyPolicyAccepted, null) > -1
                          : _vm.privacyPolicyAccepted,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.privacyPolicyAccepted,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.privacyPolicyAccepted = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.privacyPolicyAccepted = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.privacyPolicyAccepted = $$c
                          }
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "pl-1",
                        attrs: { for: "accept-privacy-policy-birthdate" },
                      },
                      [
                        _c("omegaup-markdown", {
                          attrs: {
                            markdown: _vm.formattedAcceptPolicyMarkdown,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "checkbox-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.codeOfConductAccepted,
                          expression: "codeOfConductAccepted",
                        },
                      ],
                      attrs: {
                        id: "accept-code-of-conduct-birthdate",
                        "data-signup-accept-conduct": "",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.codeOfConductAccepted)
                          ? _vm._i(_vm.codeOfConductAccepted, null) > -1
                          : _vm.codeOfConductAccepted,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.codeOfConductAccepted,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.codeOfConductAccepted = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.codeOfConductAccepted = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.codeOfConductAccepted = $$c
                          }
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "pl-1",
                        attrs: { for: "accept-code-of-conduct-birthdate" },
                      },
                      [
                        _c("omegaup-markdown", {
                          attrs: {
                            markdown: _vm.formattedAcceptConductMarkdown,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _vm.validateRecaptcha
                ? _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("vue-recaptcha", {
                        attrs: {
                          name: "recaptcha",
                          sitekey: "6LfMqdoSAAAAALS8h-PB_sqY7V4nJjFpGK2jAokS",
                        },
                        on: { verify: _vm.verify, expired: _vm.expired },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c("div", { staticClass: "col-md-4 col-md-offset-6" }, [
                _c("div", { staticClass: "form-group introjs-register" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary form-control",
                      attrs: { "data-signup-submit": "", name: "sign_up" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$emit("register-and-login", {
                            over13Checked: _vm.over13Checked,
                            username: _vm.username,
                            email: _vm.email,
                            dateOfBirth: _vm.dateOfBirth,
                            parentEmail: _vm.parentEmail,
                            password: _vm.password,
                            passwordConfirmation: _vm.passwordConfirmation,
                            recaptchaResponse: _vm.recaptchaResponse,
                            termsAndPolicies: _vm.termsAndPolicies,
                          })
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.T.loginSignUp) + " ")]
                  ),
                ]),
              ]),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }